<div class="slide">
    <div class="column-left">
        <msc-heading-actions>
            <h2 class="heading">
                {{sectionContent?.title}}
            </h2>
        </msc-heading-actions>

        <div *ngIf="showResumePrompt" class="resume-prompt">
            <p>{{ 'player.video.resume_prompt' | translate }}</p>
            <button class="btn btn-primary" (click)="resumeFromSaved()">
                {{ 'player.video.resume' | translate }}
            </button>
            <button class="btn btn-secondary" (click)="startFromBeginning()">
                {{ 'player.video.restart' | translate }}
            </button>
        </div>

        <!-- Barra sobre el video con el botón de expandir propio. El botón nativo de
             YouTube queda bloqueado por Permissions Policy al ir la app embebida en un
             iframe, así que expandimos con un overlay por CSS que funciona siempre. -->
        <div class="video-toolbar" *ngIf="!showResumePrompt">
            <button type="button" class="video-expand-btn" [class.video-expand-btn--max]="isMaximized"
                (click)="toggleMaximize()"
                [attr.title]="(isMaximized ? 'words.close' : 'player.cheatsheet.full-screen') | translate">
                <svg *ngIf="!isMaximized" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="w-4 h-4">
                    <path d="M8 3H5a2 2 0 0 0-2 2v3"></path>
                    <path d="M21 8V5a2 2 0 0 0-2-2h-3"></path>
                    <path d="M3 16v3a2 2 0 0 0 2 2h3"></path>
                    <path d="M16 21h3a2 2 0 0 0 2-2v-3"></path>
                </svg>
                <svg *ngIf="isMaximized" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="w-4 h-4">
                    <path d="M4 14h3a2 2 0 0 1 2 2v3"></path>
                    <path d="M20 10h-3a2 2 0 0 1-2-2V5"></path>
                    <path d="M14 20v-3a2 2 0 0 1 2-2h3"></path>
                    <path d="M10 4v3a2 2 0 0 1-2 2H5"></path>
                </svg>
                <span>{{ (isMaximized ? 'words.close' : 'player.cheatsheet.full-screen') | translate }}</span>
            </button>
        </div>

        <!-- Shell del video: proporción 16:9 (alto correcto) y overlay a pantalla
             completa cuando isMaximized. El iframe del player se inyecta dentro. -->
        <div class="video-shell" *ngIf="!showResumePrompt" [class.video-shell--max]="isMaximized">
            <div #playerContainer class="video-player-container"></div>
        </div>

        <!-- Etiqueta del tipo de contenido, debajo del embed -->
        <span class="block text-sm font-normal text-gray-600 my-2 px-4 py-3 bg-gray-50 border-t border-gray-200">{{ 'player.video.name' | translate }}</span>

        <msc-next-prev-btn (isFinished)="activityFinished()" [validate]="true" [doneAt]="sectionContentSession?.doneAt"></msc-next-prev-btn>
    </div>
</div>

<app-footer [context]="'video'" [contextId]="video?.id"></app-footer>

<app-timer [timerService]="timerService" (close)="timerInit()"></app-timer>

<style>
   /* @media only screen and (min-width: 320px) {
        .slide {
            margin: 1rem 0 0.5rem;
            width: 100%;
        }
    }

    @media only screen and (min-width: 768px) {
        .slide {
            margin: 8rem 0 1.5rem;
            width: 100%;
        }
    }*/

    .video-player-container {
        width: 100%;
    }

    /* Shell con proporción 16:9 para que el video tenga el alto correcto. */
    .video-shell {
        position: relative;
        width: 100%;
        aspect-ratio: 16 / 9;
        background: #000;
        border-radius: 8px;
        overflow: hidden;
    }

    .video-shell .video-player-container,
    .video-shell iframe {
        width: 100% !important;
        height: 100% !important;
        border: 0;
        display: block;
    }

    /* Fallback para navegadores sin soporte de aspect-ratio. */
    @supports not (aspect-ratio: 16 / 9) {
        .video-shell {
            height: 0;
            padding-bottom: 56.25%;
        }
        .video-shell .video-player-container,
        .video-shell iframe {
            position: absolute;
            inset: 0;
        }
    }

    /* Estado maximizado: overlay a pantalla completa (funciona aunque el botón
       nativo de YouTube esté bloqueado por estar embebido en un iframe). */
    .video-shell--max {
        position: fixed;
        inset: 0;
        z-index: 100000;
        width: 100vw;
        height: 100vh;
        aspect-ratio: auto;
        padding-bottom: 0;
        border-radius: 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    /* Barra sobre el video con el botón de expandir. */
    .video-toolbar {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 0.5rem;
    }

    .video-expand-btn {
        display: inline-flex;
        align-items: center;
        gap: 0.4rem;
        padding: 0.4rem 0.75rem;
        border: 1px solid #E8EAEF;
        border-radius: 9999px;
        background: #fff;
        color: #22304C;
        font-size: 0.8rem;
        font-weight: 600;
        cursor: pointer;
        transition: background .2s ease, border-color .2s ease;
    }

    .video-expand-btn:hover {
        background: #F6F7F9;
        border-color: #d7dbe3;
    }

    /* Mientras está maximizado, el botón flota fijo sobre el overlay para contraer. */
    .video-expand-btn--max {
        position: fixed;
        top: 16px;
        right: 16px;
        z-index: 100001;
        background: rgba(0, 0, 0, 0.6);
        color: #fff;
        border-color: transparent;
    }

    .video-expand-btn--max:hover {
        background: rgba(0, 0, 0, 0.8);
    }

    .resume-prompt {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 1rem;
        padding: 2rem;
        background: #f5f5f5;
        border-radius: 8px;
        margin-bottom: 1rem;
    }

    .resume-prompt p {
        font-size: 1rem;
        text-align: center;
    }

    .resume-prompt .btn {
        min-width: 160px;
    }
</style>
